<template>
  <component
    :is="as"
    :type="as === 'button' ? 'button' : undefined"
    :href="href"
    class="flex cursor-pointer items-center justify-between rounded-full bg-primary/20 px-3 py-1 text-sm"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { Component } from "vue"

withDefaults(
  defineProps<{
    as?: Component | keyof HTMLElementTagNameMap
    href?: string
  }>(),
  { as: "button", href: undefined }
)
</script>
